import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Aboutus from "./pages/About";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import Objectives from "./pages/Objectives";
import Activities from "./pages/Activities";
import WorkPrograms from "./pages/WorkPrograms";
import Team from "./pages/Team";
//import PrivacyPolicy from "./pages/PrivacyPolicy"




const App = () => {
  return (
    <Router>
      <Header />
      <main>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/objectives" element={<Objectives />} />
        <Route path="/Activities" element={<Activities />} />
        <Route path="/WorkPrograms" element={<WorkPrograms />} />
        <Route path="/Team" element={<Team />} />
        {/* <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} /> */}
          
        </Routes>
      </main>
      <Footer/>
    </Router>
  );
};

export default App;
